<template>
  <li
    :class="$style.root"
  >
    <slot />
  </li>
</template>

<style module lang="scss">
.root {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  padding: var(--padding--element);

  border-bottom: var(--stroke) solid;

  display: flex;
  flex-direction: column;
}
</style>
